import {RouteObject, useRoutes} from "react-router-dom";
import ModuleWrap from "../components/ModuleWrap";
import AuthLayout from "../views/layouts/AuthLayout";
import PageNotFound from "../views/errors/PageNotFound";
import Home from "../views/modules/Home";
import Terms from "../views/modules/TermsConditions/Terms";
import Policy from "../views/modules/PrivacyPolicy/Policy";
import SpecialOffer from "../views/modules/SpecialOffer/SpecialOffer";
import DeleteAccount from "../views/modules/Auth/DeleteAccount/DeleteAccount";
import SignUp from "../views/modules/AppSignUp/SignUp";

export default function Router() {
    return useRoutes(RouterConfig);
}

export const RouterConfig: RouteObject[] = [
    {
        element: <AuthLayout />,
        children: [
            {
                path: "/",
                element: <ModuleWrap module={Home} />,
            },
            {
                path: "/terms-conditions",
                element: <ModuleWrap module={Terms} />,
            },
            {
                path: "/privacy-policy",
                element: <ModuleWrap module={Policy} />,
            },
            {
                path: "/special-offer",
                element: <ModuleWrap module={SpecialOffer} title="SpecialOffer" />,
            },
            {
                path: "/delete-account",
                element: <ModuleWrap module={DeleteAccount} />,
            },
            {
                path: "/app-sign-up",
                element: <ModuleWrap module={SignUp} title="AppSignUp" />,
            },
        ],
    },
    {
        path: "*",
        element: <PageNotFound />,
    },
];
